import CARD_RENDER_LOCATION from 'containers/molecules/Card/enum-card-render-location';
import { CardTypes } from 'defs/card-types';
import * as React from 'react';

import CardDetailProduct from 'containers/molecules/Card/Detail/Product';
import CardDetailRecipe from 'containers/molecules/Card/Detail/Recipe';
import CardDetailRecommendation from 'containers/molecules/Card/Detail/Recommendation';
import CardDetailSlogan from 'containers/molecules/Card/Detail/Slogan';
import CardDetailTask from 'containers/molecules/Card/Detail/Task';
import CardDetailTip from 'containers/molecules/Card/Detail/Tip';
import CardDetailTracking from 'containers/molecules/Card/Detail/Tracking';
import DashboardCardDetailTracking from 'containers/molecules/Card/Detail/TrackingDashboard';
import CardDetailWorkout from 'containers/molecules/Card/Detail/Workout';
import CardDetailCustomWorkout from 'containers/molecules/Card/Detail/WorkoutCustom';

import FavoriteCardDetailProduct from 'containers/molecules/Card/Detail/Product';
import FavoriteCardDetailRecipe from 'containers/molecules/Card/Detail/RecipeFavorite';
import FavoriteCardDetailRecommendation from 'containers/molecules/Card/Detail/RecommendationFavorite';
import FavoriteCardDetailSlogan from 'containers/molecules/Card/Detail/Slogan';
import FavoriteCardDetailTask from 'containers/molecules/Card/Detail/TaskFavorite';
import FavoriteCardDetailTip from 'containers/molecules/Card/Detail/TipFavorite';
import FavoriteCardDetailTracking from 'containers/molecules/Card/Detail/Tracking';
import FavoriteCardDetailWorkout from 'containers/molecules/Card/Detail/WorkoutFavorite';

import PoolCardDetailRecipe from 'containers/molecules/Card/Detail/RecipePool';
import PoolCardDetailWorkout from 'containers/molecules/Card/Detail/WorkoutPool';

import { HandleCompleteType as HandleCompleteCompleteType } from 'components/hoc/Cards/withHandleComplete';
import { HandleClickCloseType, HandleClickHeartType } from 'components/hoc/Cards/withHandleProduct';
import { TerrificActionEnumType } from 'components/hoc/Cards/withTerrificBridge';
import { UiStateTypes } from 'components/hoc/Cards/withUiState';
import { CardProps, CardStateTypes } from 'components/molecules/Card';
import { CardRenderLocationType } from 'containers/molecules/Card/enum-card-render-location';
import { TrackingDescriptionIDType } from 'defs/tracking';
import { CardTypeTypes } from 'types/Card';
import { CoachType } from 'types/coach';
import { HistoryType } from 'types/withRouter';

export type CardDetailPropsType = {
	activeProgramName: string;
	parentProps: CardProps;
	location: any;
	match: any;
	programItemRef?: string;
	contentTypeExternalId: string;
	programItemExternalId: string;
	cardRenderLocation: CardRenderLocationType;
	id: number;
	dayRef?: number;
	productId?: string;
	externalId: string;
	state: CardStateTypes;
	type: CardTypeTypes;
	activeProgramId: number;
	isCheckable: boolean;
	favorite?: boolean;
	coach?: CoachType;
	currentWeight?: number;
	history: HistoryType;
	uiState: UiStateTypes;
	isUiCompleting: boolean;
	isUiUpdatingHeart: boolean;
	isUiClosing: boolean;
	onComplete: (arg: HandleCompleteCompleteType) => void;
	onClickHeart: (arg: HandleClickHeartType) => void;
	onClickClose: (arg: HandleClickCloseType) => void;
	onBackFromDetail: () => void;
	doOpenDescription: (guideId: TrackingDescriptionIDType) => void;
	onUpdateTerrificComponent: (action: TerrificActionEnumType) => void;
	setCardUIFolded: () => void;
	handleCardContentClick: () => void;
	handleShowDetailsClick: () => void;
	handleCompleteCard: (callback?: Function) => void;
	handleCardSloganFocus: (textareaDomElement: HTMLTextAreaElement) => void;
	handleToggleFavorite: () => void;
	doAddEvents: (...events: any[]) => void;
	trackCardTrackingSave: () => void;
};

const getComponentMap: () => {
	[key: string]: {
		[key: string]: (props: any) => any;
	};
} = () => ({
	[CardTypes.DynamicProduct]: {
		[CARD_RENDER_LOCATION.PROGRAM_FEED]: (props: CardDetailPropsType): React.ReactNode => (
			<CardDetailProduct {...props} />
		),
		[CARD_RENDER_LOCATION.FAVORITE]: (props: CardDetailPropsType): React.ReactNode => (
			<FavoriteCardDetailProduct {...props} />
		),
	},
	[CardTypes.Recommendation]: {
		[CARD_RENDER_LOCATION.PROGRAM_FEED]: (props: CardDetailPropsType): React.ReactNode => (
			<CardDetailRecommendation {...props} />
		),
		[CARD_RENDER_LOCATION.FAVORITE]: (props: CardDetailPropsType): React.ReactNode => (
			<FavoriteCardDetailRecommendation {...props} />
		),
	},
	[CardTypes.Recipe]: {
		[CARD_RENDER_LOCATION.PROGRAM_FEED]: (props: CardDetailPropsType): React.ReactNode => (
			<CardDetailRecipe {...props} />
		),
		[CARD_RENDER_LOCATION.FAVORITE]: (props: CardDetailPropsType): React.ReactNode => (
			<FavoriteCardDetailRecipe {...props} />
		),
		[CARD_RENDER_LOCATION.POOL]: (props: CardDetailPropsType): React.ReactNode => (
			<PoolCardDetailRecipe {...props} />
		),
	},
	[CardTypes.Task]: {
		[CARD_RENDER_LOCATION.PROGRAM_FEED]: (props: CardDetailPropsType): React.ReactNode => (
			<CardDetailTask {...props} />
		),
		[CARD_RENDER_LOCATION.FAVORITE]: (props: CardDetailPropsType): React.ReactNode => (
			<FavoriteCardDetailTask {...props} />
		),
	},
	[CardTypes.Slogan]: {
		[CARD_RENDER_LOCATION.PROGRAM_FEED]: (props: CardDetailPropsType): React.ReactNode => (
			<CardDetailSlogan {...(props as any)} />
		),
		[CARD_RENDER_LOCATION.FAVORITE]: (props: CardDetailPropsType): React.ReactNode => (
			<FavoriteCardDetailSlogan {...(props as any)} />
		),
	},
	[CardTypes.Workout]: {
		[CARD_RENDER_LOCATION.PROGRAM_FEED]: (props: CardDetailPropsType): React.ReactNode => (
			<CardDetailWorkout {...props} />
		),
		[CARD_RENDER_LOCATION.FAVORITE]: (props: CardDetailPropsType): React.ReactNode => (
			<FavoriteCardDetailWorkout {...props} />
		),
		[CARD_RENDER_LOCATION.POOL]: (props: CardDetailPropsType): React.ReactNode => (
			<PoolCardDetailWorkout {...props} />
		),
		[CARD_RENDER_LOCATION.POOL_CUSTOM]: (props: CardDetailPropsType): React.ReactNode => (
			<CardDetailCustomWorkout {...props} />
		),
	},
	[CardTypes.Tracking]: {
		[CARD_RENDER_LOCATION.PROGRAM_FEED]: (props: CardDetailPropsType): React.ReactNode => (
			<CardDetailTracking {...props} />
		),
		[CARD_RENDER_LOCATION.FAVORITE]: (props: CardDetailPropsType): React.ReactNode => (
			<FavoriteCardDetailTracking {...props} />
		),
		[CARD_RENDER_LOCATION.DASHBOARD]: (props: CardDetailPropsType): React.ReactNode => (
			<DashboardCardDetailTracking {...props} />
		),
	},
	[CardTypes.Tip]: {
		[CARD_RENDER_LOCATION.PROGRAM_FEED]: (props: CardDetailPropsType): React.ReactNode => (
			<CardDetailTip {...props} />
		),
		[CARD_RENDER_LOCATION.FAVORITE]: (props: CardDetailPropsType): React.ReactNode => (
			<FavoriteCardDetailTip {...props} />
		),
	},
});

export const CardDetail = (props: CardDetailPropsType) => {
	if (!props.type || !props.cardRenderLocation) {
		return null;
	}
	return getComponentMap()[props.type][props.cardRenderLocation](props);
};

CardDetail.displayName = 'Card(Detail)';

export default CardDetail;
